<template>
   <Catalog 
    :pageTitle="$t('Catalog')"
    :pageDescription="$t('Browse our wide selection of products')"    :pageHeadline="$t('All products')"
   />
</template>
<script setup lang="ts">
import Catalog from '~/components/templates/catalog.vue'

definePageMeta({
  layout: 'shop'
})
</script>